import { connect } from 'react-redux';
import { ROUTE_FAN_BOX_MESSAGE_EDIT, ROUTE_FAN_BOX_MESSAGE_NEW }from '../constants';
import fanboxMessagesAction from '../../../actions/fanboxMessages';
import {getCurrentClubId} from '../../../selectors/club-settings';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../selectors/crud';
import { push } from 'react-router-redux/lib/actions';
import { setHeaderTitle } from '../../../actions/layout';
import FanBoxList from './FanBoxList';

export default connect(
  (state) => ({
    headerTitle: 'Inbox',
    ...listStateFromCRUD(state.fanBoxMessages),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => {
    return {
      updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
      ...listDispatchFromCrud(dispatch, fanboxMessagesAction),
      edit: (id) => dispatch(push(ROUTE_FAN_BOX_MESSAGE_EDIT.replace(':id', id))),
      add: () => dispatch(push(ROUTE_FAN_BOX_MESSAGE_NEW))
    };
  }
)(FanBoxList);



// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxList/index.js